import { createReducer, on } from '@ngrx/store';

import { ROLES_ACTION } from '../actions';
import { DEFAULT_ROLES_STORE } from '../constants';
import { RolesState } from '../types';

export const ROLES_REDUCER = createReducer<RolesState>(
  DEFAULT_ROLES_STORE,
  on(ROLES_ACTION.onLoadRolesSuccess, (state: RolesState, { roles }) => ({
    ...state,
    rolesList: roles,
  })),
  on(
    ROLES_ACTION.onLoadPermissionListSuccess,
    (state: RolesState, { permissions, labels }) => ({
      ...state,
      permissionList: {
        labels,
        permissions: permissions,
      },
    }),
  ),
  on(
    ROLES_ACTION.onFetchUserRoleSuccess,
    (state: RolesState, { currentRole }) => ({
      ...state,
      currentEditUserRole: currentRole,
    }),
  ),
  on(ROLES_ACTION.onDeleteUserRoleSuccess, (state: RolesState, { role }) => {
    const computeData = () => {
      if (role) {
        return state.rolesList.data.filter((r) => r.id !== role.id);
      }
      return { ...state.rolesList.data };
    };
    const updatedData = computeData();
    return {
      ...state,
      rolesList: {
        data: updatedData,
        total: updatedData.length,
      },
    };
  }),
  on(ROLES_ACTION.clearCurrentUserRole, (state: RolesState) => ({
    ...state,
    currentEditUserRole: undefined,
  })),
);

//@TODO SHOULD SAVE CREATED ROLES INTO THE STORE?
